const assert = {};

assert.log = () => {

};

if (CC_DEBUG) {
    assert.log = CC_BUILD ? console.error : console.warn;
}

assert.numberRange = function (targetNumber, lowerRange, higherRange) {
    if (isNaN(targetNumber) || typeof targetNumber === 'undefined' || targetNumber < lowerRange || targetNumber > higherRange) {
        if (CC_DEBUG) {
            assert.log('Number range assertion, target:', targetNumber, 'lower:', lowerRange, 'higher:', higherRange);

        }

        return false;
    }

    return true;
};

assert.numberHigher = function (targetNumber, compareNumber) {
    if (isNaN(targetNumber) || typeof targetNumber === 'undefined' || targetNumber < compareNumber) {
        if (CC_DEBUG) {
            assert.log('Number higher assertion, target:', targetNumber, 'compareNumber:', compareNumber);
        }

        return false;
    }

    return true;
};

assert.numberLower = function (targetNumber, compareNumber) {
    if (isNaN(targetNumber) || typeof targetNumber === 'undefined' || targetNumber > compareNumber) {
        if (CC_DEBUG) {
            assert.log('Number lower assertion, target:', targetNumber, 'compareNumber:', compareNumber);
        }

        return false;
    }

    return true;
};

assert.isNull = function (target) {
    if (typeof target === 'undefined' || target === null) {
        if (CC_DEBUG) {
            assert.log('is Null assertion failed');
        }

        return true;
    }

    return false;
};

module.exports = assert;
